
import { useMediaQuery } from '@react-hook/media-query';
import React from 'react';

const Designs = () => {
  const images = [
    { img: "/image/10.png" },
    { img: "/image/8.png" },
    { img: "/image/9.png" },
    { img: "/image/7.jpg" },
    { img: "/image/16.png" },
    { img: "/image/11.png" },
    { img: "/image/6.png" },
    { img: "/image/3.png" },
    { img: "/image/2.png" },
    { img: "/image/1.png" },
    { img: "/image/17.png" },
    { img: "/image/5.png" }
  ];

  const isSmallScreen = useMediaQuery('only screen and (max-width: 670px)');
  const isMediumScreen = useMediaQuery('only screen and (max-width > 670px)');

  return (
    <>
      <div className='h-min[100vh] overflow-y-auto bg-background'>
        <div className='h-content sm:px-6 lg:px-16'>
          <div className='flex justify-center'>
            <span className='font-bold text-xl mt-6 font-Montserrat' style={{ fontSize:"26.1px" }}>OUR BEST DESIGNS</span>
          </div>
          <div className='my-3 font-semibold font-poppins' style={{ fontStyle: "italic" }}>
            <p className='flex justify-center text-justify px-5 text-sm items-center'>
              Explore our stunning digital prints. They are carefully chosen artworks with vibrant colors and intricate details. From landscapes to abstract art, there's something to spark your imagination. Customize your space and express your unique style with these exceptional prints.
            </p>
          </div>

          <div className='lg:px-10  sm:w-[70%] sm:flex-row lg:w-[100%]'>
          {/* <div className={` px-2 flex  flex-wrap   flex-row sm:w-[70%] lg:w-[50%]  bg-color-white bg-contain w-[100%] justify-between`}> */}
          <div className={`flex flex-wrap bg-color-white bg-contain w-[100%] justify-between`}>

              {images?.map((i, index) => (
                <img
                  src={i.img}
                  className={`lg:w-[15%] py-4 ${isSmallScreen ? `w-[50%] h-[26vh] px-[0.5rem] py-[0.5rem]` : ""} px-4  lg:h-[34vh] pointer-events-none`}
                  key={index}
                />
              ))}
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Designs;
